import { render, staticRenderFns } from "./publicClassDetailnew.vue?vue&type=template&id=253bca81&scoped=true"
import script from "./publicClassDetailnew.vue?vue&type=script&lang=js"
export * from "./publicClassDetailnew.vue?vue&type=script&lang=js"
import style0 from "./publicClassDetailnew.vue?vue&type=style&index=0&id=253bca81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253bca81",
  null
  
)

export default component.exports